import $ from 'jquery';
import '@fancyapps/fancybox';

// Configs
import { fancyboxConfig } from './config';

$('[data-fancybox]').fancybox(fancyboxConfig);
